<script setup lang="ts">
import type { BlockData } from '@/types';
import { useVisibleAnchor } from '@/composables/useVisibleAnchor';
import ContentComponent from './components/ContentComponent.vue';

defineProps<{
  blocks: BlockData[];
}>();

const { vTrackAnchorTarget } = useVisibleAnchor();
</script>

<template>
  <div
    v-for="({ components, link }, blockIndex) in blocks"
    :id="link && link.anchor"
    :key="blockIndex"
    v-track-anchor-target
    class="block"
  >
    <ContentComponent
      v-for="(content, componentIndex) in components"
      :key="componentIndex"
      :component-data="content"
    />
  </div>
</template>

<style lang="scss" scoped>
.block {
  margin-bottom: var(--spacing-l);
}
</style>
